module.exports = __webpack_public_path__ + "img/3.abefa04c.jpg";